export default __webpack_public_path__ + "static/media/infytq.b00e20dd.jpg";